module.exports = __webpack_public_path__ + "img/IT0000288750455.35242305.png";